import React from 'react';
import { useHistory } from 'react-router-dom';
import { ProcedureList } from '../../components';
import constants from '../../../../../core/constants';
import ContentModalOneButton from '../../components/ContentModalOneButton';
import iconExternalLink from '../../../../../assets/icons/icon-external-link.svg';
import Modal from '../../components/Modal/Modal';
import RegisterTicketLink from '../../components/RegisterTicketLink';
import routes from '../../../../components/Routes/routingMap';
import ModuleContainer from '@/presentation/components/Container';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import Spinner from '@/presentation/components/Spinner';

interface IProps {
  availableInApp: boolean;
  categoryName: string;
  closeExternal: () => void;
  handleSelectProcedure: (procedure: any) => void;
  procedureListFilter: any[];
  showExternal: boolean;
  acl: any[];
}

const ProcedureListView = ({
  availableInApp,
  categoryName,
  closeExternal,
  handleSelectProcedure,
  procedureListFilter,
  showExternal,
  acl
}: IProps) => {
  const history = useHistory();
  const filterList = () => {
    const procedureMap = new Map(
      procedureListFilter?.map((item) => [item.id, item])
    );
    const data = acl
      ?.filter(
        (item: any) =>
          item.page === 'Autogestionables' && procedureMap?.has(item.permission)
      )
      .map((item: any) => {
        const proc = procedureMap?.get(item.permission);
        return {
          permission: item.permission,
          name: proc.name,
          url: proc.url,
          procedureId: proc.procedureId,
          isNew: item.isNew
        };
      });
    return data;
  };
  const filteredProcedures = filterList();
  return (
    <ModuleContainer containerType="subsection">
      <SubsectionHeader
        title={categoryName}
        onClick={() => {
          history.push(routes.student.procedures.home);
        }}
      />
      {filteredProcedures.length > 0 ? (
        <ProcedureList
          procedureList={filteredProcedures}
          handleSelectProcedure={handleSelectProcedure}
        />
      ) : (
        <Spinner />
      )}

      <RegisterTicketLink />
      <Modal show={showExternal} handleClose={closeExternal}>
        <ContentModalOneButton
          img={iconExternalLink}
          title="Atención"
          subtitle="Serás redirigido al portal del estudiante para realizar tu solicitud."
          showInfo={availableInApp}
          info={
            <>
              Esta solicitud también está disponible en <b>UTP+ App</b>
            </>
          }
          textButton="Entendido"
          onClickButton={() => {
            window.open(constants.PE_URL, '_blank');
            closeExternal();
          }}
        />
      </Modal>
    </ModuleContainer>
  );
};

export default ProcedureListView;
